module.exports = __webpack_public_path__ + "img/left-arrow-circled.c833616d.svg";